import simpleFetch from "../../../utils/simpleFetch";
import { setSessionCookies, removeSessionCookies } from "../common/sessions/tokenHelper";

class loginApi {

  static sendPasswordResetLink(data) {
    return simpleFetch("post", "/v1/auth/initiate-reset-password", {
      body: data,
    });
  }

  static resetPassword(formData, token, redirectCallback) {
    return simpleFetch("post", "/v1/auth/reset-password", {
      body: {
        ...formData,
        token: token,
      },
    }).then(redirectCallback);
  }

  static validatePasswordResetToken(token) {
    return simpleFetch("post", "/v1/auth/validate-reset-token", {
      body: {
        token: token,
      },
    });
  }

  static login(body) {
    return simpleFetch("POST", "/v1/auth/login", { body }).then(
      (result) => {
        if (!result.passwordExpired) {
          const sortedAssociatedClients = result.user && result.user.associatedClients
            && result.user.associatedClients.slice().sort((a, b) => a.name.localeCompare(b.name));
          const validAssociatedClientIds = sortedAssociatedClients
           && sortedAssociatedClients.map((c) => c.clientId);
          setSessionCookies(result.accessToken, result.refreshToken);
          sessionStorage.setItem(
            "associatedClientIds",
            JSON.stringify(validAssociatedClientIds || [])
          );
          sessionStorage.setItem(
            "associatedClients",
            JSON.stringify(sortedAssociatedClients || [])
          );  
          localStorage.setItem("languageCode", result.user.languageCode);
          localStorage.setItem(
            "roleAccess",
            result.user.relationships.role.object.roleRelationships
          );
          localStorage.setItem("roleId", result.user.roleId);
        }
        return result;
      },
      (error) => {
        removeSessionCookies();
        sessionStorage.removeItem("associatedClientIds");
        sessionStorage.removeItem("associatedClients");
        localStorage.removeItem("languageCode");
        localStorage.removeItem("roleAccess");
        localStorage.removeItem("roleId");
        throw error;
      }
    );
  }
}

export default loginApi;



// WEBPACK FOOTER //
// ./src/components/login/loginApi.js